module.exports = __webpack_public_path__ + "media/3_36.8a94db69.wav";